import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { InfoIcon, XCircleIcon } from "@phosphor-icons/react";

import { Banner, Button, TextArea } from "@alpacahq/ui/old";

import { CryptoSelect } from "../presentation/CryptoSelect";
import type { UseLegacyAddWhitelistAddressReturn } from "./useLegacyAddWhitelistAddress";

export const LegacyAddWhitelistAddressModal = ({
  isOpen,
  onClose,
  symbolOptions,
  symbol,
  symbolError,
  onSymbolChange,
  address,
  addressError,
  onAddressChange,
  onSubmit,
  isSubmitDisabled,
  isSubmitLoading,
}: UseLegacyAddWhitelistAddressReturn) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    className="relative z-50 overflow-y-auto"
  >
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-black/30 duration-300 ease-out data-closed:opacity-0"
    />
    <div className="fixed inset-0 w-screen overflow-y-auto p-4">
      <div className="flex min-h-full items-center justify-center">
        <DialogPanel
          transition
          className="flex w-full max-w-[503px] flex-col items-center justify-center gap-4 rounded border border-gray-200 bg-white p-4 duration-300 ease-out data-closed:scale-95 data-closed:opacity-0"
        >
          <DialogTitle className="m-0 p-0 text-left font-semibold text-gray-800 text-lg">
            Add New Address
          </DialogTitle>
          <form
            className="flex w-full flex-col gap-4"
            onSubmit={(event) => event.preventDefault()}
          >
            <CryptoSelect
              label="Select Crypto Asset"
              options={symbolOptions}
              value={symbol}
              onChange={onSymbolChange}
              errorMessage={symbolError}
              className="w-full"
            />

            <TextArea
              label="Enter Address"
              value={address}
              onChange={(e) => onAddressChange(e.target.value)}
              rightIcon={
                address ? (
                  <button
                    type="button"
                    onClick={() => onAddressChange("")}
                    className="top-1/2 -translate-y-1/2"
                  >
                    <XCircleIcon size={20} />
                  </button>
                ) : undefined
              }
              errorMsg={addressError}
              className="min-h-10 w-full"
            />

            <Banner
              variant="info"
              icon={<InfoIcon size={20} className="text-light-blue-600" />}
              message={
                <p className="m-0 p-0 text-gray-800 text-sm">
                  Activating whitelist address will take approximately 24 hours
                  to be able to initiate withdrawals
                </p>
              }
              className="border border-light-blue-600 bg-[rgba(186,230,253,0.24)]"
            />

            <div className="flex items-center justify-end gap-4">
              <Button
                variant="v2/stroke"
                type="button"
                onClick={onClose}
                disabled={isSubmitLoading}
              >
                Cancel
              </Button>

              <Button
                variant="v2/filled"
                type="submit"
                onClick={onSubmit}
                disabled={isSubmitDisabled}
                loading={isSubmitLoading}
              >
                Submit
              </Button>
            </div>
          </form>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
);
